const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
  window.location.hostname === "[::1]" ||
  window.location.hostname.match(
    /^127(?:\.\d+){0,2}\.\d+$/,
  ),
);

export function register() {
  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      // Get the dynamic app_id from the URL path
      let appId = localStorage.getItem("app_id");

      if (!appId) {
        appId = window.location.pathname.split('/')[1]; // Extract app_id from the URL path
        if (appId) {
          // Store app_id in localStorage for future use
          localStorage.setItem("app_id", appId);
        }
      }

      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      if (appId) {
        // If there's an app_id, set the service worker scope to match the app_id
        const serviceWorkerScope = `/${appId}/`; // Dynamic scope for the app_id

        // Register service worker with the specific scope
        if (isLocalhost) {
          // Running on localhost, check for updates
          checkValidServiceWorker(swUrl, serviceWorkerScope);
        } else {
          registerValidSW(swUrl, serviceWorkerScope);
        }
      } else {
        // Default behavior if no app_id is present in the URL
        if (isLocalhost) {
          checkValidServiceWorker(swUrl);
        } else {
          registerValidSW(swUrl);
        }
      }
    });
  }
}

function registerValidSW(swUrl, scope = '/') {
  navigator.serviceWorker
    .register(swUrl, { scope })
    .then((registration) => {
      // console.log("Service Worker registered successfully:", registration);
    })
    .catch((error) => {
      console.error("Service Worker registration failed:", error);
    });
}

function checkValidServiceWorker(swUrl, scope = '/') {
  fetch(swUrl)
    .then((response) => {
      if (
        response.status === 404 ||
        response.headers.get("content-type")?.indexOf("javascript") === -1
      ) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        registerValidSW(swUrl, scope);
      }
    })
    .catch(() => {
      console.log("No internet connection. Running in offline mode.");
    });
}
